import styled from "styled-components";

export const CalendarContainer = styled.div``;
